import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'
import Vue from 'vue'

const requireComponent = require.context(
  '@/components', true, /\.vue$/, 'lazy'
)

requireComponent.keys().forEach((fileName) => {
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')),
  )

  Vue.component(componentName, () =>
    requireComponent(fileName).then((componentConfig: any) => componentConfig.default || componentConfig),
  )
})
